import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MkpSellerOrderContainerModel } from '../../../../../models';
import { Core2Config } from '../shared';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';

@Injectable({ providedIn: 'root' })
export class MkpSellerOrderService extends BaseApiPublicLoginTemplateService<MkpSellerOrderContainerModel,MkpSellerOrderContainerModel, MkpSellerOrderContainerModel> {
    static readonly SELLER_ORDER_SUB_PATH = 'seller-orders/';
    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MKP_PREFIX + MkpSellerOrderService.SELLER_ORDER_SUB_PATH;

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MKP_PREFIX + MkpSellerOrderService.SELLER_ORDER_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MKP_PREFIX + MkpSellerOrderService.SELLER_ORDER_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;

        this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MKP_PREFIX + MkpSellerOrderService.SELLER_ORDER_SUB_PATH + BaseApiTemplateService.LOGIN_ENTITY_EP;
        this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MKP_PREFIX + MkpSellerOrderService.SELLER_ORDER_SUB_PATH + BaseApiTemplateService.LOGIN_ENTITY_EP;
        this.httpClient = http;
    }
}